import type {ReactElement} from 'react';
import {useSelectedComponent} from '@FormMakerReact/hooks/use-selected-component';
import {TileList} from './components/tile-list/tile-list';
import styles from './form-maker-bottom-bar.module.scss';

export function FormMakerBottomBar(): ReactElement {
  const selected = useSelectedComponent();
  return (
    <div className={styles.bar} role="region" aria-label={window.i18next.t('pmwjs_form_maker_bottom_bar_aria')}>
      <TileList selected={selected} />
    </div>
  );
}
